/* eslint-disable react/jsx-key */
import AuthorizedRoute from 'base-shell/lib/components/AuthorizedRoute';
import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import UnauthorizedRouteV2 from './auth/UnauthorizedRouteV2';
import AuthorizedRouteV2 from './auth/AuthorizedRouteV2';
import { BUILDER_KEYS } from 'utils/tabUtils';

const Redirect301 = ({ to }) => {
  React.useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'prerender-status-code';
    meta.content = '301';
    document.head.appendChild(meta);

    const headerMeta = document.createElement('meta');
    headerMeta.name = 'prerender-header';
    headerMeta.content = `Location: https://instaresume.io${to}`;
    document.head.appendChild(headerMeta);
    return () => {
      // document.head.removeChild(meta);
      // document.head.removeChild(headerMeta);
    };
  }, []);
  return <Navigate to={to} replace />;
};

const About = lazy(() => import('../pages/About'));
const Contact = lazy(() => import('../pages/Contact'));
const Designs = lazy(() => import('../pages/Designs'));
const CourseTabs = lazy(() => import('../pages/Courses/courseTabs'));
const TermsConditions = lazy(() => import('../pages/TermsConditions'));
const LicensesAndAttribution = lazy(
  () => import('pages/LicensesAndAttribution'),
);
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
const ResumeScanHistory = lazy(() => import('pages/ResumeScanHistory'));
const CookiesConsent = lazy(() => import('../pages/CookiesConsent'));
const Resumes = lazy(() => import('../pages/Resumes'));
const Builder = lazy(() => import('../pages/Builder'));
const Blogs = lazy(() => import('../pages/Blogs/blogs'));
const LiveURL = lazy(() => import('../pages/LiveURL'));
const CoverLetterBuilder = lazy(
  () => import('sanityWebpages/CoverletterBuilder'),
);
const CoverLetterGenerator = lazy(
  () => import('sanityWebpages/CoverLetterGenerator'),
);
const AtsResumeScore = lazy(() => import('sanityWebpages/AtsResumeScore'));
const TailorYourResume = lazy(() => import('sanityWebpages/TailorYourResume'));

const AiResumeBuilder = lazy(() => import('sanityWebpages/AiResumeBuilder'));
const LinkedinChromeExtension = lazy(
  () => import('sanityWebpages/LinkedinChromeExtension'),
);

const ResumeWritingServices = lazy(
  () => import('../pages/ResumeWritingServices'),
);
const ResumeReport = lazy(() => import('../pages/ResumeReport'));
const CVWritingPricing = lazy(() => import('../pages/CVWritingPricing'));
const CVWritingServices = lazy(() => import('../pages/CVWritingServices'));
const MyAccount = lazy(() => import('../pages/MyAccount'));
const FreeCredits = lazy(() => import('../pages/FreeCredits'));
const Pricing = lazy(() => import('../sanityWebpages/Pricing'));
const ResumeTemplateInfo = lazy(() => import('../pages/ResumeTemplateInfo'));
const BlogTabs = lazy(() => import('../pages/Blogs/BlogTabs'));
const ApiUsage = lazy(() => import('../pages/ApiUsage'));
const routes = [
  {
    path: '/terms-and-conditions',
    exact: true,
    element: <TermsConditions />,
  },
  {
    path: '/terms&conditions',
    exact: true,
    element: <TermsConditions />,
  },
  {
    path: '/privacy',
    exact: true,
    element: <PrivacyPolicy />,
  },
  {
    path: '/cookies-concent',
    exact: true,
    element: <CookiesConsent />,
  },

  {
    path: '/resume-templates',
    exact: true,
    element: <Designs />,
  },
  {
    path: '/contact',
    exact: true,
    element: <Contact />,
  },
  {
    path: '/about',
    exact: true,
    element: <About />,
  },
  {
    path: '/blogs',
    exact: true,
    element: <BlogTabs selectedTab={'1'} />,
  },
  {
    path: '/blogs/page/:pageNumber',
    exact: true,
    element: <BlogTabs selectedTab={'1'} />,
  },
  {
    path: '/browse-by-categories',
    exact: true,
    element: <BlogTabs selectedTab={'2'} />,
  },
  {
    path: '/browse-by-categories/:category',
    exact: true,
    element: <BlogTabs selectedTab={'2'} />,
  },
  {
    path: '/interview-series',
    exact: true,
    element: <BlogTabs selectedTab={'3'} />,
  },
  {
    path: '/linkedin-profile-optimization-blogs',
    exact: true,
    element: <BlogTabs selectedTab={'4'} />,
  },
  {
    path: '/quick-tips',
    exact: true,
    element: <BlogTabs selectedTab={'5'} />,
  },

  {
    path: '/resume-templates/:template',
    exact: true,
    element: <ResumeTemplateInfo />,
  },
  {
    path: '/blog',
    exact: true,
    element: <Blogs />,
  },

  {
    path: '/blog/:blogId',
    exact: true,
    element: <Blogs />,
  },
  {
    path: '/resumes',
    exact: true,
    element: (
      <AuthorizedRouteV2>
        <Resumes />
      </AuthorizedRouteV2>
    ),
  },
  {
    path: '/resume/:resumeId/edit',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Builder />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/demo/edit',
    exact: true,
    element: (
      <UnauthorizedRouteV2>
        <Builder resume />
      </UnauthorizedRouteV2>
    ),
  },
  {
    path: '/demo/bio-data/edit',
    exact: true,
    element: (
      <UnauthorizedRouteV2>
        <Builder bioData />
      </UnauthorizedRouteV2>
    ),
  },
  {
    path: '/demo/cover/edit',
    exact: true,
    element: (
      <UnauthorizedRouteV2>
        <Builder coverLetter />
      </UnauthorizedRouteV2>
    ),
  },
  {
    path: '/cover/:resumeId/edit',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Builder coverLetter />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/bio-data/:resumeId/edit',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Builder bioData />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/resignation/:resumeId/edit',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Builder resignationLetter />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/demo/resignation/edit',
    exact: true,
    element: (
      <UnauthorizedRouteV2>
        <Builder resignationLetter />
      </UnauthorizedRouteV2>
    ),
  },
  {
    path: '/courses',
    exact: true,
    element: <CourseTabs selectedTab={'1'} />,
  },
  {
    path: '/artificial-intelligence-courses',
    exact: true,
    element: <CourseTabs selectedTab={'2'} />,
  },
  {
    path: '/data-analyst-courses',
    exact: true,
    element: <CourseTabs selectedTab={'3'} />,
  },
  {
    path: '/software-engineer-courses',
    exact: true,
    element: <CourseTabs selectedTab={'4'} />,
  },
  {
    path: '/search-engine-optimization-courses',
    exact: true,
    element: <CourseTabs selectedTab={'5'} />,
  },

  {
    path: '/resume-writing-services',
    exact: true,
    element: <ResumeWritingServices />,
  },

  {
    path: '/cv-writing-services',
    exact: true,
    element: <CVWritingServices />,
  },
  {
    path: '/cv-writing-pricing',
    exact: true,
    element: <CVWritingPricing />,
  },
  {
    path: '/tailor-resume',
    exact: true,
    element: <TailorYourResume />,
  },
  {
    path: '/linkedin-review',
    exact: true,
    element: <LinkedinChromeExtension />,
  },
  {
    path: '/resume-report/:scanId',
    exact: true,
    element: (
      <AuthorizedRoute>
        <ResumeReport />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/resume-scan-history',
    exact: true,
    element: (
      <AuthorizedRoute>
        <ResumeScanHistory />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/resume-report',
    exact: true,
    element: (
      <AuthorizedRoute>
        <ResumeReport />
      </AuthorizedRoute>
    ),
  },

  {
    path: '/account',
    exact: true,
    element: (
      <AuthorizedRoute>
        <MyAccount />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/free-credits',
    exact: true,
    element: (
      <AuthorizedRoute>
        <FreeCredits />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/account/usage',
    exact: true,
    element: (
      <AuthorizedRoute>
        <ApiUsage />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/resume/view/:id',
    exact: true,
    element: <LiveURL context={BUILDER_KEYS.resumes} />,
  },
  {
    path: '/resume/view/:id/:clone',
    exact: true,
    element: <LiveURL context={BUILDER_KEYS.resumes} />,
  },
  {
    path: '/bio-data/view/:id',
    exact: true,
    element: <LiveURL context={BUILDER_KEYS.bioData} />,
  },
  {
    path: '/bio-data/view/:id/:clone',
    exact: true,
    element: <LiveURL context={BUILDER_KEYS.bioData} />,
  },
  {
    path: '/cover/view/:id',
    exact: true,
    element: <LiveURL context={BUILDER_KEYS.covers} />,
  },
  {
    path: '/cover/view/:id/:clone',
    exact: true,
    element: <LiveURL context={BUILDER_KEYS.covers} />,
  },
  {
    path: '/resignation/view/:id',
    exact: true,
    element: <LiveURL context={BUILDER_KEYS.resignationLetters} />,
  },
  {
    path: '/resignation/view/:id/:clone',
    exact: true,
    element: <LiveURL context={BUILDER_KEYS.resignationLetters} />,
  },
  {
    path: '/licenses-and-attribution',
    exact: true,
    element: <LicensesAndAttribution />,
  },
  {
    path: '/cover-letter-builder',
    exact: true,
    element: <CoverLetterBuilder />,
  },
  {
    path: '/cover-letter-generator',
    exact: true,
    element: <CoverLetterGenerator />,
  },
  {
    path: '/pricing',
    exact: true,
    element: <Pricing />,
  },
  {
    path: '/resume-checker',
    exact: true,
    element: <AtsResumeScore />,
  },
  {
    path: '/free-ai-resume-builder-tool',
    exact: true,
    element: <AiResumeBuilder />,
  },
  {
    path: '/ai-resume-builder',
    exact: true,
    element: <Redirect301 to='/free-ai-resume-builder-tool' />,
  },
];

export default routes;
